import { gql } from "../../../__generated__/gql";

import { gql as gqlClient } from "@apollo/client";

export const GET_EDITION = gql(`
query festivalEdition($id: String!) {
  festivalEdition(where: { id: $id }) {
    name
    year
    timezone
    announcements {
      id
      name
      editionId
      bands {
            id
        showcase
        band {
          id
          name
          description
          imageUrl
          bookings {
            id
            startTime
            endTime
          }
        }
        date
        duration
        stage {
          id
          name
          order
        }
        startTime
        endTime
      }
    }

    #
    bands {
      id
  showcase
  band {
    id
    name
    description
    imageUrl
    bookings {
      id
      startTime
      endTime
    }
  }
  date
  duration
  stage {
    id
    name
    order
  }
  startTime
  endTime
    }
    days {
      id
      date
      name
    }
  }
}  
`);

export const GET_EDITION_BANDS = gqlClient(`
  query festivalEditionBands($id: String!) {
    festivalEdition(where: { id: $id }) {
      name
      timezone
      announcements {
        id
        name
        editionId
        availabilityDate
        bands {
          id
          startTime
          endTime
          duration
          stage {
            name
          }
          band {
            id
            name
            imageUrl
            description
          }
        }
      }
      bands {
        id
        startTime
        endTime
        duration
        stage {
          name
        }
        band {
          id
          name
          imageUrl
        }
      }
    }
  }
`);

export const EXPORT_FESTIVAL =
  gql(`query clashfinderExport($name: String!, $id:String!) {
  clashfinderExport(name: $name, id:$id)
}`);
